import dayjs from "dayjs";

export type SalePlanningTask = {
    id: number,
    saleId: number,
    taskName: string,
    taskDescription: string,
    startDate: string,
    endDate: string,
    nextNotificationDate: string | null,
    isComplete: boolean,
    priority: number,
    daysBetweenNotifications: number,
    assignedToUserId: number | null
}

export type SalePlanningTaskIndex = {
    [taskId: number]: SalePlanningTask
}

export type CreatePlanningTaskDTO = {
    saleId: number,
    taskName: string,
    taskDescription: string,
    startDate: string,
    endDate: string,
    priority: number,
    daysBetweenNotifications: number,
    assignedToUserId: number | null
}

export const DefaultCreatePlanningTaskDTO = (saleId: number): CreatePlanningTaskDTO => ({
    saleId,
    taskName: '',
    taskDescription: '',
    startDate: dayjs().format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    priority: 3,
    daysBetweenNotifications: 0,
    assignedToUserId: null
})
